export default {
  xs: 600,
  sm: 900,
  md: 1200,
  lg: 1800,
  xl: 2200
};
